import { Stack } from '@src/components';

import { AbsenceEditPanel, Timeline} from './components';
import { AbsencesTimelineProvider } from './context';


export default function AbsenceTimeline() {
  return (
    <AbsencesTimelineProvider>
      <Stack direction="row">
        <Timeline />
        <AbsenceEditPanel />
      </Stack>
    </AbsencesTimelineProvider>
  );
}
